export const formatPhoneNumber = (phoneNumber: string, dialCode = "") => {
  const formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
  return `${dialCode} ${formattedPhoneNumber}`;
};
